export var BaseMapsName;
(function (BaseMapsName) {
    BaseMapsName["2GIS"] = "2gis";
    BaseMapsName["YMapsSchema"] = "yMapsSchema";
    BaseMapsName["YMapsHybrid"] = "yMapsHybrid";
    BaseMapsName["YMapsEng"] = "yMapsEng";
})(BaseMapsName || (BaseMapsName = {}));
export const baseMapsList = [
    {
        name: BaseMapsName["2GIS"],
        title: "Карты 2ГИС",
        sourceUrl: "https://tile0.maps.2gis.com/tiles?x={2}&y={3}&z={1}&ts=online_sd&layerType=nc",
    },
    {
        name: BaseMapsName.YMapsSchema,
        title: "Яндекс.Карты (Схема)",
        sourceUrl: "https://core-renderer-tiles.maps.yandex.net/tiles?l=map&v=23.11.01-0-b231030182430&x={2}&y={3}&z={1}&lang=ru_RU",
    },
    {
        name: BaseMapsName.YMapsHybrid,
        title: "Яндекс.Карты (Гибрид)",
        sourceUrl: "https://core-renderer-tiles.maps.yandex.net/tiles?l=skl&v=22.01.29-1-b211218133230&x={2}&y={3}&z={1}&lang=ru_RU",
    },
    {
        name: BaseMapsName.YMapsEng,
        title: "Yandex Map (Eng)",
        sourceUrl: "https://core-renderer-tiles.maps.yandex.net/tiles?l=map&v=23.11.01-0-b231030182430&x={2}&y={3}&z={1}&lang=en_US",
    },
];
